import Component from '@ember/component';
import { computed, getProperties, get } from '@ember/object';
import { service } from '@ember/service';
import { empty } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';

/* attrs
  - field (coaching/individual sectionField)
  - report - the coach report
  - individual - the coach individual record
  - propertyName
  - goalType - interval|overall  - overall is default
*/
export default Component.extend({
  tagName: 'span',
  coachingService: service(),

  field: null,
  report: null,
  individual: null,
  propertyName: null,
  goalType: 'overall',

  percent: computed(
    'field.id',
    'report.id',
    'propertyName',
    'goalType',
    function () {
      let {
        field,
        report,
        individual,
        propertyName,
        goalType,
        coachingService,
      } = getProperties(
        this,
        'field',
        'report',
        'individual',
        'propertyName',
        'goalType',
        'coachingService',
      );
      let val =
        goalType === 'interval'
          ? coachingService.getFieldValueDiff(field, report, individual, {
              propertyName,
            })
          : coachingService.getFieldValue(field, report, { propertyName });

      if (isEmpty(val)) {
        return null;
      }
      let goal =
        goalType === 'interval'
          ? get(field, 'intervalGoal.low')
          : field.overallGoal;
      return (val * 100) / goal;
    },
  ),

  percentIsEmpty: empty('percent'),
});
